import { createReducer, on, Action, ActionReducerMap } from "@ngrx/store";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import * as DocumentActions from "./document.actions";

export const DOCUMENT_FEATURE_KEY = "genericdocument";

export enum UploadStatus {
  Ready = "Ready",
  Requested = "Requested",
  Started = "Started",
  Failed = "Failed",
  Completed = "Completed",
}

export interface DocumentState extends EntityState<any> {
  selectedId?: string | number; // which Model Type record has been selected
  loaded: boolean; // has the Model list been loaded
  error?: string | null; // last none error (if any)
  status: UploadStatus;
  progress: number | null;
}

export interface DocumentPartialState {
  readonly [DOCUMENT_FEATURE_KEY]: DocumentState;
}

export const documentAdapter: EntityAdapter<any> = createEntityAdapter<
  any
>({
  selectId: (record) => record && record.id,
  sortComparer: false,
});

export const initialState: DocumentState = documentAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedId: null,
  status: UploadStatus.Ready,
  progress: null,
});

export const documentReducer = createReducer(
  initialState,
  on(DocumentActions.loadAcquisitionDocument, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    DocumentActions.loadAcquisitionDocumentSuccess,
    (state, { document }) =>
    documentAdapter.setAll(document, {
        ...state,
        loaded: false,
      }),
  ),
  on(DocumentActions.loadAcquisitionDocumentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(DocumentActions.addAcquisitionDocument, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    DocumentActions.addAcquisitionDocumentSuccess,
    (state, { newDocument }) =>
    documentAdapter.upsertMany(newDocument, {
        ...state,
        loaded: false,
      }),
  ),
  on(DocumentActions.addAcquisitionDocumentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(DocumentActions.documentUploadRequest, (state) => ({
    ...state,
    loaded: true,
    error: null,
    status: UploadStatus.Requested,
    progress: null,
  })),
  on(
    DocumentActions.documentUploadSuccess,
    (state, { newDocument }) =>
    documentAdapter.upsertOne(newDocument, {
        ...state,
        loaded: false,
        error: null,
        status: UploadStatus.Ready,
        progress: null,
      }),
  ),
  on(DocumentActions.documentUploadCancel, (state) => ({
    ...state,
    // loaded: false,
    error: null,
    status: UploadStatus.Ready,
    progress: null,
  })),
  on(DocumentActions.documentUploadReset, (state) => ({
    ...state,
    // loaded: false,
    error: null,
    status: UploadStatus.Ready,
    progress: null,
  })),
  on(DocumentActions.documentUploadFailure, (state, { error }) => ({
    ...state,
    // loaded: false,
    error: error,
    status: UploadStatus.Failed,
    progress: null,
  })),
  on(DocumentActions.documentUploadStarted, (state) => ({
    ...state,
    loaded: true,
    error: null,
    status: UploadStatus.Started,
    progress: 0,
  })),
  on(DocumentActions.documentUploadProgress, (state, { progress }) => ({
    ...state,
    loaded: true,
    error: null,
    progress: progress,
  })),
  on(DocumentActions.documentUploadCompleted, (state) => ({
    ...state,
    // loaded: false,
    error: null,
    status: UploadStatus.Completed,
    progress: 100,
  })),
  on(DocumentActions.loadClearAcquisitionDocument, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    DocumentActions.loadClearAcquisitionDocumentSuccess,
    (state, { document }) =>
    documentAdapter.setAll(document, {
        ...state,
        loaded: false,
      }),
  ),
);

export function reducer(state: DocumentState | undefined, action: Action) {
  return documentReducer(state, action);
}
